import { render } from "./BottomBar.vue?vue&type=template&id=19a1ba85&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=19a1ba85&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19a1ba85"

export default script